var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-weight-bold",class:{
    'red--text': _vm.valueAsNumberOrNull && _vm.valueAsNumberOrNull < _vm.mediaMinima,
    'success--text': _vm.valueAsNumberOrNull && _vm.valueAsNumberOrNull >= _vm.mediaMinima,
  }},[_vm._v(_vm._s(!_vm.valueIsEmpty ? _vm.valueAsNumberOrNull.toFixed(1) : "- - -"))])
}
var staticRenderFns = []

export { render, staticRenderFns }